import React, { useState } from "react";
import styled from "styled-components/macro";
import { MonitorBox } from "./MonitorBox";
import { UnitBox } from "./UnitBox";
import tuluUnitLogo from "../../images/unit/tuluUnitLogo.png";

const RoomUnit = ({
  showDimensions,
  columns,
  colorUnit,
  logoImage,
  itemsCount,
}) => {
  const [popupItem, setPopupItem] = useState();

  const _renderColumns = () => {
    return columns?.map((column, columnIndex) => {
      return (
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "row",
          }}
          key={columnIndex}
        >
          <DividerVertical />
          <div>
            {column?.map((item, index) => {
              if (!item) return null;

              if (item.type === "monitor") {
                return (
                  <MonitorBox
                    key={index}
                    frameColor={colorUnit}
                    popupItem={popupItem}
                    colorUnit={colorUnit}
                    logo={logoImage && URL.createObjectURL(logoImage)}
                  />
                );
              }

              return (
                <UnitBox
                  colorUnit={colorUnit}
                  item={item}
                  showTopDivider
                  quantity={itemsCount[item.id]}
                  showBottomDivider={index + 1 === column.length}
                  showRightDivider={columnIndex + 1 !== columns.length}
                  key={index}
                  popupItem={popupItem}
                  onPopupClose={() => setPopupItem(null)}
                  onPopupOpen={() => setPopupItem(item)}
                />
              );
            })}
          </div>
          <DividerVertical />
          {columns.length - 1 !== columnIndex && (
            <DividerVertical
              style={{
                backgroundImage: "linear-gradient(to bottom, white, white)",
                width: "5px",
              }}
            />
          )}
        </div>
      );
    });
  };

  const cmHorizontal = 48.25 * columns.length + 2 * (columns.length - 1);
  const cmVertical = 210;

  return (
    <WrapperUnit>
      {showDimensions && (
        <DimensionsHorizontalWrapper>
          <div>{`${fromCmToInch(cmHorizontal)}`}</div>
          <DimensionsHorizontal />
        </DimensionsHorizontalWrapper>
      )}
      {showDimensions && (
        <DimensionsVerticalWrapper>
          <div style={{ padding: "0 4px" }}>{`${fromCmToInch(
            cmVertical
          )}`}</div>
          <DimensionsVertical />
        </DimensionsVerticalWrapper>
      )}
      <Shelf frameColor={colorUnit} color={colorUnit}>
        <TuluUnitLogo src={tuluUnitLogo} />
      </Shelf>
      <Unit>{_renderColumns()}</Unit>

      <Shelf frameColor={colorUnit} height={30} />
    </WrapperUnit>
  );
};

const DividerVertical = styled.div`
  width: 10px;
  box-shadow: 0 0 1px #4a4a4a;
  background-image: linear-gradient(to bottom, #f9f3e9, #f9f3e9);
`;
const WrapperUnit = styled.div`
  transform: scale(0.9);
  position: fixed;
  align-self: flex-end;
`;
const Unit = styled.div`
  z-index: 999;
  display: flex;
  position: relative;
  flex-direction: row;
`;

const DimensionsVerticalWrapper = styled.div`
  position: absolute;
  top: 0;
  left: -68px;
  height: 100%;
  z-index: 1;
  color: #ffffff;
  font-size: 20px;
  text-align: center;
  display: flex;
  align-items: center;
`;

const DimensionsVertical = styled.div`
  height: 100%;
  z-index: 1;
  width: 3px;
  background-color: #ffffff;
  border-radius: 8px;
`;

const DimensionsHorizontalWrapper = styled.div`
  position: absolute;
  top: -35px;
  left: 0;
  width: 100%;
  z-index: 1;
  color: #ffffff;
  font-size: 20px;
  text-align: center;
`;

const DimensionsHorizontal = styled.div`
  width: 100%;
  z-index: 1;
  height: 3px;
  background-color: #ffffff;
  border-radius: 8px;
`;
const TuluUnitLogo = styled.img`
  padding: 5px 15px;
  object-fit: contain;
  width: 150px;
`;

const Shelf = styled.div`
  display: flex;
  position: relative;
  height: ${({ height = 70 }) => height}px;
  width: 100%;
  border-radius: 2px;
  z-index: 9999;
  box-shadow: -2px 1px 20px -8px #4a4a4a;
  background-color: ${({ frameColor }) => frameColor};
`;
export { RoomUnit };

const fromCmToInch = (cm) => {
  let inches = (cm * 0.393700787).toFixed(0);
  const feet = Math.floor(inches / 12);
  inches %= 12;

  return `${feet}" ${inches}'`;
};
